/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Guides_Analysis_AfterInputs */

const en_gc_guides_analysis_after = /** @type {(inputs: Gc_Guides_Analysis_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare the summary against the original rows. In the miniature dataset below, North should total 720 and all regions should total 1,040. A chart should answer the same question as the table it uses; a clear title and consistent units make it easier to interpret. Save an XLSX copy, reopen it and inspect both the data and its summary. When a workbook will be exchanged with Excel, review the chart and PivotTable there as well.`)
};

const zh_gc_guides_analysis_after = /** @type {(inputs: Gc_Guides_Analysis_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请将汇总与原始记录进行比较。下方小数据集中，North 应合计 720，总计应为 1,040。图表应回答与来源表格相同的问题，清晰标题和一致单位更便于理解。保存 XLSX 副本后重新打开，检查数据与汇总。若需要与 Excel 交换，还应在 Excel 中复查图表和数据透视表。`)
};

/**
* | output |
* | --- |
* | "Compare the summary against the original rows. In the miniature dataset below, North should total 720 and all regions should total 1,040. A chart should answ..." |
*
* @param {Gc_Guides_Analysis_AfterInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_guides_analysis_after = /** @type {((inputs?: Gc_Guides_Analysis_AfterInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Guides_Analysis_AfterInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_guides_analysis_after(inputs)
	return zh_gc_guides_analysis_after(inputs)
});
export { gc_guides_analysis_after as "gc.guides.analysis.after" }